import { useCallback } from 'react';

import { ITEM_TYPE } from '../../const';
import { useSidebarEvents } from '../../service';
import { useMainActions } from '../../store';

export const useHandlers = ({ items }) => {
  const { trackNavigationItemClicked } = useSidebarEvents();
  const mainActions = useMainActions();

  const handleToggleSubmenu = useCallback(
    (submenuItem) => {
      mainActions.toggleSubmenu(submenuItem?.id);
    },
    [mainActions]
  );

  const handleLinkClick = useCallback(
    (linkItem) => {
      trackNavigationItemClicked(linkItem.label);

      // No need to do anything if all submenus are collapsed now
      if (!mainActions.getExpandedSubmenu()) {
        return;
      }

      const linkItemParent = items.find((item) => {
        if (item.type === ITEM_TYPE.submenu) {
          return item.items.includes(linkItem);
        }

        return false;
      });

      if (!linkItemParent) {
        mainActions.collapseAllSubmenus();
      }
    },
    [items, mainActions, trackNavigationItemClicked]
  );

  return {
    handleToggleSubmenu,
    handleLinkClick,
  };
};
